import { Toolbar, Item, DataGridRef } from "devextreme-react/data-grid";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { StockDS } from "../../dataSources/StockDS";
import { openPopup } from "../../helper/DxHelper";
import { basicSettings } from "../../helper/GridCreator/gridConfig";
import GridCreator from "../../helper/GridCreator/GridCreator";
import { stockActions } from "../../redux/stock/stock-slice";
import { GridType, Stock } from "@/types/types";
import { Link } from "react-router-dom";
import Insert from "./Insert";
import Update from "./Update";
import useHeaderChangeNoUP from "@/hooks/useHeaderChangeNoUP";
import { PopupRef } from "devextreme-react/cjs/popup";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";
import { useAppSelector } from "@/hooks/useAppSelector";

export default function StockList() {
  useHeaderChangeNoUP("Stock");
  const { user } = useAppSelector((state) => state.system);
  const datagridRef = useRef<DataGridRef>(null);
  const insertPopupRef = useRef<PopupRef>(null);
  const updatePopupRef = useRef<PopupRef>(null);
  const dispatch = useDispatch();

  const addButtonOptions = {
    icon: "plus",
    onClick: () => {
      openPopup(insertPopupRef);
    },
  };

  function renderToolbar() {
    return (
      <Toolbar>
        <Item
          location="after"
          locateInMenu={"auto"}
          widget="dxButton"
          options={addButtonOptions}
          cssClass="dx-datagrid-insert-button"
        />
        <Item name="columnChooserButton" location="after" />
        <Item name="searchPanel" location="after" />
      </Toolbar>
    );
  }

  const gridSettings: GridType<Stock, string> = {
    ...basicSettings,
    ref: datagridRef,
    id: "suGrid",
    dataSource: StockDS(),
    toolbar: renderToolbar,
    columns: [
      {
        key: "cmd",
        width: 90,
        cellRender: cmdCellRender,
        allowExporting: false,
        allowHiding: false,
        allowResizing: false,
        showInColumnChooser: false,
      },
      {
        key: "stockId",
        dataField: "id",
        visible: false,
        allowEditing: false,
      },
      {
        key: "name",
        dataType: "string",
        dataField: "name",
        visible: true,
        allowEditing: false,
      },
      {
        key: "code",
        dataField: "code",
        dataType: "string",
        visible: true,
        allowEditing: false,
        hidingPriority: 4,
      },
      // {
      //   key: "salesforceID",
      //   dataField: "salesforceID",
      //   dataType: "string",
      //   visible: true,
      //   allowEditing: false,
      //   hidingPriority: 4,
      // },
    ],
  };

  function cmdCellRender(e: ColumnCellTemplateData<Stock>) {
    return (
      <div className="flex items-center gap-x-2">
        <button
          title="edit"
          onClick={() => {
            openPopup(updatePopupRef);
            dispatch(
              stockActions.setEditStockData({
                code: e.row.data.code,
                id: e.row.data.id,
              })
            );
          }}
        >
          <img src="/icons/edit-icon.svg" />
        </button>
        <Link
          onClick={() => {
            dispatch(
              stockActions.setEditStockData({
                code: e.row.data.code,
                id: e.row.data.id,
              })
            );
          }}
          to={`/stock/${e.row.data.id}/browse`}
        >
          <img src="/icons/eye-icon.svg" alt="" />
        </Link>
      </div>
    );
  }

  return (
    <>
      {user?.isAdmin ? (
        <>
          <Insert popupRef={insertPopupRef} datagridRef={datagridRef} />
          <Update popupRef={updatePopupRef} datagridRef={datagridRef} />
          <GridCreator {...gridSettings} />
        </>
      ) : null}
    </>
  );
}
